import { Router } from 'next/router';
import { useCallback, useEffect } from 'react';

import { useRouter, useServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

/**
 * 콘솔 이용 중, 브라우저 상에서 api 호출로 401인 상황일 때 에러 시 라우트 이동하도록하는 코드를 차단하기 위한 effect
 * 콘솔 상에서 401일 경우, 로그인이 필요하기 때문에 해제 불가능한 모달이 생성되어 있음. 이 때의 경우만 다른 에러들과 다르게 라우트 이동을 막아야함.
 */
const useBlockRouteEffect = () => {
  const router = useRouter();
  const {
    state: { status },
  } = useServiceAppState();

  const handleRouteStart = useCallback(
    (url: string, params: { shallow: boolean }) => {
      if (status !== STATUS_CODE.UNAUTHORIZED_EXPIRED_TOKEN) return;

      const blockMessage = `Route blocked: Unauthorized expired token`;

      router.events.emit('routeChangeError', blockMessage, params);
      throw new Error(blockMessage);
    },
    [status, router],
  );

  useEffect(() => {
    Router.events.on('routeChangeStart', handleRouteStart);

    return () => {
      Router.events.off('routeChangeStart', handleRouteStart);
    };
  }, [handleRouteStart]);
};

export default useBlockRouteEffect;
